import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CueMessagePayload, CueMessageState } from 'src/app/models/fincas/cue.model';

/** Displays the latest CUE operation result without mixing it with flow logic. */
@Component({
  selector: 'app-cue-result-summary',
  templateUrl: './cue-result-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CueResultSummaryComponent {
  @Input()
  public importResult: CueMessagePayload | null = null;

  @Input()
  public messageState: CueMessageState = '';

  public get body(): string {
    return this.importResult?.data?.[0]?.body ?? '';
  }

  public get hasMessage(): boolean {
    return this.messageState !== '';
  }

  public get severity(): Exclude<CueMessageState, ''> | 'info' {
    return this.messageState || 'info';
  }

  public get title(): string {
    return this.importResult?.statusMessage ?? 'Resultado del envío';
  }
}
